import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RosterCreateTriggerService {
  readonly pendingDate = signal<string | null>(null);
}
